// Module
var code = "<template> <img ref=\"imgElement\" src.bind=\"imgSrc\"/> </template>";
// Exports
export default code;